import { EventEmitter2 } from 'eventemitter2';

export default new EventEmitter2({
  maxListeners: 999,
});
